import { useEffect } from "react";
import useAuth from "src/hooks/useAuth";
import useLocales from "src/hooks/useLocales";

const FreshChatWidget = () => {
  const { isAuthenticated } = useAuth();
  const { currentLang } = useLocales();
  const user = JSON.parse(localStorage.getItem("profile") ?? "{}");
  useEffect(() => {
    if (isAuthenticated && user) {
      const freshworksScript = document.querySelector('script[chat="true"]');

      if (!freshworksScript) {
        const script = document.createElement("script");
        script.src = "//eu.fw-cdn.com/12995931/948505.js";
        script.setAttribute("chat", "true");
        document.head.appendChild(script);
      }

      window.fcSettings = {
        onInit: async function () {
          if (window.fcWidget) {
            window.fcWidget.setExternalId(user.userId);
            window.fcWidget.user.setFirstName(user.firstName);
            window.fcWidget.user.setEmail(user.email);
            window.fcWidget.user.setProperties({
              email: user.email,
              e_mail: user.email,
            });
            window.fcWidget.setConfig({ locale: currentLang.value });
            await window.fcWidget.user.setLocale(currentLang.value);
            window.fcWidget.on("widget:opened", async function (resp) {
              if (window.fcWidget) {
                await window.fcWidget.user.setLocale(currentLang.value);
                window.fcWidget.setConfig({ locale: currentLang.value });
              }
              //Function to do some task
            });
          }
        },
      };
    }
  }, [isAuthenticated, user]);

  useEffect(() => {
    if (window.fcWidget) {
      window.fcWidget.on("widget:opened", async function (resp) {
        console.log("Widget Opened");
        if (window.fcWidget) {
          await window.fcWidget.user.setLocale(currentLang.value);
          window.fcWidget.setConfig({ locale: currentLang.value });
          console.log("lang updated on open");
        }
        //Function to do some task
      });
    }
  }, [currentLang]);

  return null;
};

export default FreshChatWidget;
